import { createStore } from "vuex";

import ProfireLine from "@/store/modules/ProfireLine";
import AuthModule from "@/store/modules/AuthModule";
import RegisterModel from "@/store/modules/RegisterModel";
import Benefit from "@/store/modules/Benefit";

const store = createStore({
  modules: {
    ProfireLine,
    AuthModule,
    RegisterModel,
    Benefit
  },
});

export default store;
